var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNotice = function SvgNotice(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D4D4D4",
    d: "M4.125 19a1.16 1.16 0 0 1-.801-.288A.92.92 0 0 1 3 18q0-.424.324-.712.324-.287.801-.288H5.25v-7q0-2.074 1.406-3.687Q8.063 4.701 10.313 4.2v-.7q0-.625.492-1.062A1.74 1.74 0 0 1 12 2q.703 0 1.196.438.492.438.492 1.062v.7q2.25.5 3.656 2.113T18.75 10v7h1.125q.478 0 .802.288T21 18a.92.92 0 0 1-.324.713 1.16 1.16 0 0 1-.801.287zM12 22q-.928 0-1.588-.587T9.75 20h4.5q0 .825-.66 1.413T12 22m-4.5-5h9v-7q0-1.65-1.322-2.825Q13.857 6 12 6T8.822 7.175 7.5 10z"
  })));
};
export default SvgNotice;